import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const SHOW_AFTER_PX = 560;

export default function StickyMobileCta() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (user) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-mobile-cta"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 28 }}
          className="fixed inset-x-0 bottom-0 z-[60] border-t-2 border-[var(--c-border)] bg-[var(--c-bg-95)] px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur sm:hidden"
        >
          <div className="flex items-center gap-3">
            <div className="min-w-0 flex-1">
              <p className="truncate font-heading text-sm font-black text-[var(--c-text)]">Steps 0–2 free · Full guide $19</p>
              <p className="flex items-center gap-1 text-[11px] text-[var(--c-muted)]"><ShieldCheck className="h-3 w-3" /> No card needed · 30-day guarantee</p>
            </div>
            <button
              data-testid="sticky-mobile-cta-button"
              onClick={() => navigate("/login?mode=register")}
              className="inline-flex flex-shrink-0 items-center gap-1.5 rounded-full border-2 border-[var(--c-border)] bg-[#C8102E] px-4 py-2.5 text-sm font-bold text-white shadow-[3px_3px_0px_var(--c-shadow)] active:translate-y-0.5"
            >
              Start Free <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
